import * as CryptoJS from 'crypto-js';

export default async config => {
  const useDynamicConfig = config.dangerouslyUseDynamicConfig;

  // Check if dangerouslyUseDynamicConfig enabled
  if (useDynamicConfig?.enabled) {
    // If enabled then get configUrl query-string
    let query = new URLSearchParams(window.location.search);

    // Check for encrypted params
    const encryptedParams = query.get('params');
    if (encryptedParams) {
      try {
        const decrypted = CryptoJS.AES.decrypt(encryptedParams, 'z!!!!!!!1sdfadsf56adf456asdfasdf');
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        const decryptedParams = new URLSearchParams();
        if (decryptedString.trim().startsWith('{')) {
          const decryptedJson = JSON.parse(decryptedString);
          Object.entries(decryptedJson).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              decryptedParams.set(key, String(value));
            }
          });
        } else {
          const parsed = new URLSearchParams(decryptedString);
          for (const [key, value] of parsed) {
            decryptedParams.set(key, value);
          }
        }
        // Merge decrypted params into query
        for (const [key, value] of decryptedParams) {
          const existingValue = query.get(key);
          if (
            existingValue === null ||
            existingValue === '' ||
            existingValue === 'null' ||
            existingValue === 'undefined'
          ) {
            query.set(key, value);
          }
        }
      } catch (error) {
        console.error('Failed to decrypt params:', error);
      }
    }

    let configUrl = query.get('configUrl');

    if (configUrl) {
      // validate regex
      const regex = useDynamicConfig.regex;

      if (configUrl.match(regex)) {
        const response = await fetch(configUrl);
        return response.json();
      } else {
        return null;
      }
    }
  }
  return null;
};
